import { Box, BoxProps } from '@chakra-ui/react/box';

export type DotProps = Omit<BoxProps, 'boxSize'> & {
  size: BoxProps['boxSize'];
};

// Replaces bitkit v1's `Dot` so the call sites stay greppable; decide per site later whether the dot is
// still wanted at all, rather than hunting for anonymous round Boxes.
const Dot = ({ size, ...rest }: DotProps) => <Box aria-hidden borderRadius="full" boxSize={size} {...rest} />;

export default Dot;
